import React from 'react';
import { LockIcon } from 'lucide-react';
const cards = [{
  name: 'VISA',
  className: 'text-[#1A1F71] bg-white'
}, {
  name: 'MC',
  className: 'text-white bg-[#EB001B]'
}, {
  name: 'AMEX',
  className: 'text-white bg-[#2E77BC]'
}, {
  name: 'PayPal',
  className: 'text-[#003087] bg-white'
}];
type TrustRowProps = {
  className?: string;
  align?: 'left' | 'center';
};
export function TrustRow({
  className = '',
  align = 'left'
}: TrustRowProps) {
  return <div className={`flex flex-wrap items-center gap-x-3 gap-y-2 ${align === 'center' ? 'justify-center' : ''} ${className}`} data-id="element-127" data-mp="1p1wi812zsi1h">
      <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-white/60" data-id="element-128" data-mp="1yyj1wmjl131x">
        <LockIcon className="h-3.5 w-3.5 text-emerald-400" aria-hidden="true" data-id="element-129" data-mp="1tydgho3wocsa" />
        Pago seguro con cifrado SSL
      </span>
      <span className="h-3 w-px bg-white/15" aria-hidden="true" data-id="element-130" data-mp="3abtu7662irvp" />
      <ul className="flex items-center gap-1.5" aria-label="Métodos de pago aceptados" data-id="element-131" data-mp="35ebrhxin98w5">
        {cards.map(card => <li key={card.name} className={`rounded px-1.5 py-1 text-[10px] font-bold leading-none tracking-tight ${card.className}`} data-id="element-132" data-mp="3fvnsncmgg643">
            {card.name}
          </li>)}
      </ul>
    </div>;
}